import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { templateKeys } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import markUrl from './markUrl';
const useTemplateEditorContext = (target, enabled = true) => {
    const additional = useQueryRequestParams();
    return useQuery({
        queryKey: templateKeys.editorContext(target),
        queryFn: () => axios.get(markUrl('mark-templates/editor-context/'), {
            ...additional,
            params: target
        }),
        enabled,
        staleTime: 300_000
    });
};
export default useTemplateEditorContext;
